import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../../context/useAppContext';

import { TransitionActionHandler } from './ActionsHandler';

import { SelectLabel, RadioLabel, CheckboxLabel, TooltipHelp } from '@weezevent/nacre';

import { TranslatableInput } from '../../components';

export const TransitionActionSettings = ({ action, handleAction, handleActionObject, languageOptions, defaultLanguage }) => {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const actionOptions = TransitionActionHandler.get_allowed_actions(organization.id).map(act => ({
        text: t(`ticket.moderation.statusesTransitions.transition.steps.actions.${act}`),
        value: act
    }));

    const handleChange = React.useCallback(
        (field, value, selectedLanguage) => {
            let trans = action.translations;
            trans[field][selectedLanguage] = value;
            if (selectedLanguage !== defaultLanguage) {
                if (!value) {
                    trans[field][selectedLanguage] = '';
                }
                handleAction('translations', trans);
            } else {
                handleActionObject({ ...action, [field]: value, translations: trans });
            }
        },
        [handleActionObject, handleAction, action, defaultLanguage]
    );

    return (
        <>
            <TranslatableInput
                field="name"
                label_prefix="ticket.common"
                placeholder_prefix="ticket.common"
                item={action}
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                handleChange={handleChange}
            />
            <TranslatableInput
                field="description"
                label_prefix="ticket.common"
                placeholder_prefix="ticket.common"
                item={action}
                inputType="text"
                defaultLanguage={defaultLanguage}
                languageOptions={languageOptions}
                handleChange={handleChange}
            />

            <SelectLabel
                label={t('ticket.moderation.statusesTransitions.transition.steps.actions.actionTypeLabel')}
                useNew
                value={action.type}
                options={actionOptions}
                placeholder={t('ticket.common.action.select')}
                onChange={value => handleAction('type', value)}
                disabled={Boolean(action.id)}
            />

            {t('ticket.moderation.statusesTransitions.transition.steps.actions.actionOptionlabel')}
            <div>
                <RadioLabel bordered inline checked={action.optional_value === null} name="mandatory" onClick={() => handleAction('optional_value', null)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.mandatoryActionLabel')}
                </RadioLabel>
                <RadioLabel bordered inline checked={action.optional_value !== null} name="optional" onClick={() => handleAction('optional_value', false)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.facultativeActionLabel')}
                </RadioLabel>
            </div>

            <CheckboxLabel
                label={
                    <span>
                        {t('ticket.moderation.statusesTransitions.transition.steps.actions.defaultActiveLabel')}
                        <TooltipHelp triggerOnHover title={t('ticket.moderation.statusesTransitions.transition.steps.actions.defaultActiveDesc')} />
                    </span>
                }
                disabled={action.optional_value === null}
                checked={action.optional_value === null ? true : action.optional_value}
                onChange={({ target: { checked } }) => handleAction('optional_value', checked)}
            />
        </>
    );
};
